<template>
  <div class="index">
    <el-form v-if="uploadCont != 1">
        <el-form-item label="合同:" prop="workNum">
          <fileUpload v-model="workNum" @input="handleInput"  :isShowTip="false" :limit="1" :fileType="['png', 'jpg', 'pdf']" :workerId="queryData.id"/>
        </el-form-item>
    </el-form>
    <div class="index-top">
      <p>卡号：{{ queryParam.workerId }}</p>
      <p>手机号：{{ phoneNumber }}</p>
      <p>会员名：{{ userName }}</p>
    </div>
    <el-button v-if="uploadCont == 1" type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
      @click="handleCreateOne()">上传合同</el-button>
    <div class="table-container" style="margin-top: 10px">
      <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }"
        v-loading="listLoading" max-height="650" border>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="relateId" label="客户" v-if="false"></el-table-column>
        <el-table-column prop="type" label="文件类型"></el-table-column>
        <el-table-column prop="content" label="文件名称"></el-table-column>
        <el-table-column prop="content" label="文件预览">
          <template slot-scope="props">
            <el-image style="width: 100px; height: 100px" :src="props.row.filePath" :preview-src-list="srcList">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="filePath" label="文件链接" v-if="false">
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small"
              v-if="isAdmin == true">删除</el-button>
            <!-- <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="上传文件" :visible.sync="visibleDlgAdd" width="25%" center append-to-body>
      <div>
        <el-form ref="addForm" :model="addParam" :rules="rules" label-width="150px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addParam.content" placeholder="文件名"></el-input>
          </el-form-item>
          <el-form-item label="上传文件：">
            <el-upload :action="uploadAction" :headers="importHeaders" :on-success="handleUploadSuccess"
              :file-list="fileList" :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
              <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件,图片文件不超过500kb</div>-->
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleAddOne">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import globaldata from "../../../utils/globaldata";
import commonUtils from "../../../utils/commonUtils";
import { addFile, viewFile, deleteFile, workerContract ,uploadContract} from "../../../api/StoreWorkers";
import { addAgreement } from "../../../api/userByCard";
import { getStaticData } from "@/api/staticData";
import messageUtils from "../../../utils/messageUtils";
import { getToken } from "@/utils/auth";
import fileUpload from "@/components/Upload/fileUpload";

export default {
  components: { fileUpload },
  props: {
    queryData: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    uploadCont: {
      type: Number,
      default: 1,
    }
  },

  data() {
    return {
      workNum:'',
      fileList: [],
      srcList: [],
      videoFileList: [],
      visitPicList: [],
      refreVisitPic: "",
      uploadAction: "",
      importHeaders: "",
      listLoading: true,
      storeFrontId: globaldata.getAdminStore().storeFrontId,
      //查询参数
      queryParam: {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        //分页查询
        pageNum: 1, //当前第几页
        pageSize: 10,
      },
      totalPage: 1, //总共页数
      pageSizes: [20, 50, 100],
      //查询区域默认展开
      activeName: 1,
      createParam: {},
      //删除
      deleteParam: {},
      addParam: {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        type: "",
        path: "",
      },
      //弹窗
      visibleDlgAdd: false,
      //表单结果
      tableData: [],
      allWorker: [],
      options: [
        {
          value: "image",
          label: "图片",
        },
        {
          value: "video",
          label: "视频",
        },
      ],
      photoTypes: [],
      rules: {
        content: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        type: [{ required: true, message: "请选择内容类型", trigger: "blur" }],
        path: [{ required: true, message: "请上传资源", trigger: "blur" }],
      },
      props: {
        isAdmin: {
          type: Boolean,
          default: false,
        },
      },
      phoneNumber: "",
      cardName: "",
      userName: "",
      lessonTemplateId: 999,
      cardType: "",
    };
  },

  created() {
    console.log(this.queryData,'this.queryData=======')
    // this.queryParam.workerId = this.queryData.workerId;
    this.queryParam.workerId = this.queryData.id;
    this.queryParam.type = "2";
    // this.phoneNumber = this.queryData.phoneNumber;
    this.phoneNumber = this.uploadCont == 1 ? this.queryData.userPhone : this.queryData.phone;
    this.userName = this.uploadCont == 1 ? this.queryData.childName : this.queryData.name;

    this.cardName = this.queryData.cardName;
    // this.userName = this.queryData.childName;
    this.lessonTemplateId = this.queryData.lessonTemplateId;
    if (this.lessonTemplateId === "1") {
      this.cardType = "亲子游";
    }
    if (this.lessonTemplateId === "2") {
      this.cardType = "基础游";
    }

    globaldata.getStorePosition(this.getStorePosition);
    if (globaldata.getAdminStore().userRole == "adminWorker") {
      this.isAdmin = true;
    }

    this.fitchList();
    let mytoken = getToken();
    this.importHeaders = { Authorization: mytoken };
    getStaticData("").then((response) => {
      let data = response.data;
      if (commonUtils.isObjectNull(data)) {
        return;
      }
      this.uploadAction =
        data.uploadChildPhotoImageUrl + "/" + this.storeFrontId;
    });
  },

  methods: {
    handleInput(e){
      if(e){
        uploadContract({
          workerId: this.queryData.id,
          contract:e
        }).then(res=>{
          if(res.code == 20000){
            messageUtils.successMsg(this, "上传入职合同成功!");
            this.fitchList();

          }else{
            messageUtils.erroewMsg(this, res.message);

          }

        })
      }
    },
    //点击查询按钮
    onBtnSearch() {
      this.fitchList();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.fitchList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.fitchList();
    },
    refreshData(list) {
      for (let i = 0; i < list.length; ++i) {
        if (list[i].type == "1") {
          list[i].type = "入职文件";
        } else if (list[i].type == "6") {
          list[i].type = "离职文件";
        } else if (list[i].type == "2") {
          list[i].type = "购卡合同";
        }
      }
      this.tableData = list;
      this.loadAll();
    },
    //添加一个
    handleCreateOne() {
      this.visibleDlgAdd = true;
    },
    handleUploadSuccess(res, file) {
      if (res.code != 20000) {
        messageUtils.errorMsg(this, res.message);
        return;
      }
      messageUtils.successMsg(this, "上传成功");
      this.addParam.path = res.data;
    },
    handleVideoUploadSuccess(res, file) {
      if (res.code != 20000) {
        messageUtils.errorMsg(this, res.message);
        return;
      }
      messageUtils.successMsg(this, "上传成功");
      this.addParam.videoPath = res.data;
    },
    //刪除
    handleDeleteOne(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: row.id,
            storeFrontId: row.storeFrontId,
            content: row.content,
            filePath: row.filePath,
            relateId: row.relateId,
            createTime: row.createTime,
            type: row.type,
          };
          deleteFile(param).then((response) => {
            let code = response.code;
            if (code == 20000) {
              messageUtils.successMsg(this, response.message);
              this.fitchList();
            } else {
              messageUtils.errorMsg(this, response.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    fitchList() {
      this.listLoading = true;

      if (this.uploadCont == 1) {
        // this.queryParam.relateId = this.$route.query.workerId;
        // this.queryParam.type = this.$route.query.type;
        let param = {
          pageNum: 1,
          pageSize: 10,
          type: '2',
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          relateId: this.queryData.id,
          workerId: this.queryData.id,
        }
        viewFile(param).then((response) => {
          console.log(response,'response=========')
          this.listLoading = false;
          let data = response.data;
          console.info(data);
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data);
        });
      } else if (this.uploadCont == 2) { //；员工信息合同
        this.queryParam.relateId = this.$route.query.workerId;
        this.queryParam.type = this.$route.query.type;
        this.queryParam.storeFrontId = this.queryData.storeFrontId;
        this.queryParam.workerId = this.queryData.id;
        // console.log(this.queryParam ,this.queryData,'============111111')
        //       return
        workerContract(this.queryParam).then((response) => {
          this.listLoading = false;
          let data = response.data;
          console.info(data);
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data);
        })
      }
    },

    loadAll() {
      if (this.uploadCont == 1) {
        // let param = this.queryParam;
        // param.pageNum = 1;
        // param.pageSize = 30;
        // param.relateId = this.$route.query.workId;
        // param.type = this.$route.query.type;
        let param = {
          pageNum: 1,
          pageSize: 10,
          type: '2',
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          relateId: this.queryData.id,
          workerId: this.queryData.workerId,
        }
        viewFile(param).then((response) => {
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          this.srcList = [];
          for (let i = 0; i < data.length; ++i) {
            this.srcList.push(data[i].filePath);
          }
        });
      } else if (this.uploadCont == 2) {
        let param = this.queryParam;
        param.pageNum = 1;
        param.pageSize = 30;
        param.storeFrontId = this.queryData.storeFrontId;
        param.workerId = this.queryData.id;
        viewFile(param).then((response) => {
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          this.srcList = [];
          for (let i = 0; i < data.length; ++i) {
            this.srcList.push(data[i].filePath);
          }
        });
      }
    },

    handleAddOne() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let param = {
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            relateId: this.queryData.id,
            // relateId: this.$route.query.workerId,
            filePath: this.addParam.path,
            content: this.addParam.content,
            type: '2',
            // type: this.$route.query.type,
          };
          addAgreement(param).then((response) => {
            let code = response.code;
            if (code == 20000) {
              messageUtils.successMsg(this, response.message);
              this.visibleDlgAdd = false;
              this.fitchList();
            } else {
              messageUtils.errorMsg(this, response.message);
            }
          });
          this.addParam = {};
          this.fileList = [];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  &-top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    p {
      margin: 0px 15px 10px 0px;
      font-size: 16px;
    }
  }
}

/deep/ .el-table th.el-table__cell>.cell {
  //   width: 90%;
  height: 100%;
  background: #ecf3fd;
  //   border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/UploadContract.vue